export default function Autocomplete() {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        popupIndicator: {
          width: 'auto',
          height: 'auto',
        },
        clearIndicator: {
          width: 'auto',
          height: 'auto',
        },
      },
    },
  };
}
